import { Component, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ITextColumnsTileDefinition } from '../../../dashboards/interfaces/tiles/definitions/text-columns-tile-definition.interface';
import { ISelectOption } from '../../interfaces/select-option.interface';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';
import { TileSetupWizardComponent } from '../tile-setup-wizard.component';

@Component({
  standalone: false,
  selector: 'lib-free-trial-setup-wizard',
  templateUrl: './free-trial-setup-wizard.component.html',
  styleUrls: ['../shared-tile-creator-styles.scss', './free-trial-setup-wizard.component.scss'],
})
export class FreeTrialSetupWizardComponent extends TileSetupWizardComponent<ITextColumnsTileDefinition> {
  verticalPositionsOptions: ISelectOption[];
  fontSizesOptions: string[];

  textColumns;

  constructor(
    private readonly fb: FormBuilder,
    private readonly tileCreatorService: TileCreatorService,
  ) {
    super();

    this.tileInstance = inject(TILE_REQUEST).tileInstance;
  }

  ngOnInit() {
    this.initSetupForms();

    this.hookForm();
  }

  initSetupForms() {
    this.setupForm = this.fb.group({
      background: '',
    });

    if (this.tileInstance) {
      this.setupForm.patchValue(this.tileInstance);
    }
  }

  onCreate() {
    Object.assign(this.tileInstance, this.getChanges());
    this.tileCreatorService.onChange.next();
  }

  getChanges() {
    return {
      tileType: 'free-trial',
      canView: 'true',
      ...this.setupForm.value,
    };
  }
}
